function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', 'false');

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN'];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => {
    video.pause();
  });
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

// Buy with Prime remove or separator
function updateOrSeparator() {
  try {
    if (document.querySelector('.bwp-widget-loaded')) {
      document.querySelector('#wyze-buy-with-prime').style = 'display:block';
    } else {
      document.querySelector('#wyze-buy-with-prime').style = 'display:none';
    }
  } catch (error) {
    console.error(error);
  }
}
class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });

    this.querySelectorAll('button').forEach((button) => button.addEventListener('click', this.onButtonClick.bind(this)));
  }

  onButtonClick(event) {
    event.preventDefault();

    const {
      input: {
        max,
        value,
        value: previousValue,
        dataset: { title }
      }
    } = this;

    const {
      target: { name }
    } = event;

    if (max && name === 'plus' && parseInt(value) >= parseInt(max)) {
      alert(`The requested quantity exceeds the maximum allowed (${max}) for ${title}.`);
    }

    name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) {
      this.input.dispatchEvent(this.changeEvent);

      // Buy with Prime sync quantity
      try {
        let selectedQuantity = document.querySelector("input[name='quantity']").value;
        selectedQuantity = parseInt(selectedQuantity);
        document.getElementById('amzn-buy-now').setAttribute('data-quantity', selectedQuantity);
        let selectedSku = document.querySelector('#amzn-buy-now').getAttribute('data-sku');
        // call Buy with Prime button updater function
        bwp.updateWidget(selectedSku, selectedQuantity);
      } catch (error) {
        // console.error(error);
      }

      if (this.input.value === '1') this.querySelectorAll('button')[0].disabled = true;
      else this.querySelectorAll('button')[0].disabled = false;
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on' + eventName, callback);
};

// add to cart function that keeps customer on the same page
Shopify.addToCart = function (items) {
  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(items)
  })
    .then((response) => {
      return response.json();
    })
    .catch((error) => {
      console.error('Error:', error);
    });
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach((button) => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove('menu-opening');
      this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
      });
      document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
      });
    }
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
    // Auto load for featured video
    if (this.classList.contains('product-media-modal--featured-video')) {
      this.querySelector('deferred-media button').click();
    }
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    if (poster.hasAttribute('autoplay')) this.intersectAutoplay(poster);
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  intersectAutoplay(poster) {
    const options = {
      threshold: 0.25
    };

    const callback = (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.loadContent();
          observer.unobserve(this);
        }
      });
    };

    const observer = new IntersectionObserver(callback, options);

    observer.observe(poster);
  }

  loadContent() {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      this.appendChild(content.querySelector('video, model-viewer, iframe')).focus();

      const video = this.querySelector('video');

      // Force video to play if user scrolls within viewport
      if (video.hasAttribute('data-ensure-playback-in-viewport')) {
        const options = {
          threshold: 0.25
        };
        const callback = (entries, observer) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              window.pauseAllMedia();
              video.play();
            }
          });
        };
        const observer = new IntersectionObserver(callback, options);
        observer.observe(video);
      }
      // Autoplay video Safari fix
      else if (video?.hasAttribute('autoplay') || this.hasAttribute('data-accordion-video')) {
        video
          .play()
          .then()
          .catch((err) => console.error(err));
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('ul');
    this.sliderItems = this.querySelectorAll('li');
    this.pageCount = this.querySelector('.slider-counter--current');
    this.pageTotal = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    const sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    this.sliderLastItem = sliderItemsToShow[sliderItemsToShow.length - 1];
    if (sliderItemsToShow.length === 0) return;
    this.slidesPerPage = Math.floor(this.slider.clientWidth / sliderItemsToShow[0].clientWidth);
    this.totalPages = sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  update() {
    if (!this.pageCount || !this.pageTotal) return;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderLastItem.clientWidth) + 1;

    if (this.currentPage === 1) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.currentPage === this.totalPages) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }

    this.pageCount.textContent = this.currentPage;
    this.pageTotal.textContent = this.totalPages;
  }

  onButtonClick(event) {
    event.preventDefault();
    const slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + this.sliderLastItem.clientWidth
        : this.slider.scrollLeft - this.sliderLastItem.clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateMaxAmount();
    this.updateMaxAmountInput();
    this.checkNotificationForm();
    // Buy with Prime
    this.updateBuyWithPrime(this.currentVariant.sku);
    // Klarna
    this.updateKlarna();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.updateAltCtaVariantInput();
      this.fetchMainSection().then((html) => {
        this.renderProductInfo(html);
        this.renderVariantSelect(html);
        this.renderSellingPlanRadios();
        this.renderRelatedSellingPlanRadios();
        this.renderAddonProducts(html);
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
      this.renderSubNavigation('product-sub-navigation');
      this.renderSubNavigation('product-sticky-mobile');
    }
  }

  // Buy with Prime sync variant SKU
  updateBuyWithPrime(selectedSku) {
    try {
      let selectedQuantity = document.querySelector("quantity-input.quantity input[name='quantity']").value;
      selectedQuantity = parseInt(selectedQuantity);
      
      // sku override function
      let wyzeVariantSkuOverrideCheck = document.querySelector("input[data-product-variant-id='" + this.currentVariant.id + "']")
      let wyzeSkuOverride = wyzeVariantSkuOverrideCheck.getAttribute('data-product-sku-override');
      if ( wyzeSkuOverride !== null ) {
        console.log('BwP Sku Override:', wyzeSkuOverride);
        // override selectSku variable
        selectedSku = wyzeSkuOverride;
      }

      // set attribute for BwP widget
      document.getElementById('amzn-buy-now').setAttribute('data-sku', selectedSku);
      // call Buy with Prime button updater function
      bwp.updateWidget(selectedSku, selectedQuantity);
      setTimeout(updateOrSeparator, 1000);
    } catch (error) {
      // console.error(error);
    }
  }

  updateKlarna() {
    try {
      window.Klarna.OnsiteMessaging.refresh();
    } catch (error) {
      // Klarna is not shown on every PDP page
      // console.error(error);
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    const newMedia = document.querySelector(`[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`);

    if (!newMedia) return;
    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    const parent = newMedia.parentElement;
    if (parent.firstChild == newMedia) return;
    modalContent.prepend(newMediaModal);
    parent.prepend(newMedia);

    // move video button el
    const videoButton = document.querySelector('.featured-video-product-modal-opener');
    if (videoButton) parent.querySelector('modal-opener').appendChild(videoButton);

    this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
    if (this.stickyHeader) {
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }
    window.setTimeout(() => {
      parent.scrollLeft = 0;
      parent.querySelector('li.product__media-item').scrollIntoView({ behavior: 'smooth' });
    });
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    const url = new URL(window.location.href);
    url.searchParams.set('variant', this.currentVariant.id);

    // window.location
    window.history.replaceState({}, '', url.href);

    // share button
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton) return;
    shareButton.updateUrl(url.href);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateAltCtaVariantInput() {
    if (!this.hasAttribute('data-featured-product')) {
      const productForms = document.querySelectorAll(`#product-form-sub-navigation, #product-form-sticky-mobile`);
      productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  updateMaxAmount() {
    let variantId = this.currentVariant.id.toString();
    let hiddenMaxAmount = document.querySelector('#variant-' + variantId);
    let quantityInput = document.querySelector(`#Quantity-${this.dataset.section}`);
    if (hiddenMaxAmount != null) {
      let {
        dataset: { title }
      } = hiddenMaxAmount;
      hiddenMaxAmount = hiddenMaxAmount.getAttribute('data-max-amount');
      if (quantityInput != null) {
        quantityInput.setAttribute('max', hiddenMaxAmount);
        quantityInput.dataset.title = title;
        quantityInput.value = 1;
      }
    } else if (quantityInput?.hasAttribute('data-max')) {
      quantityInput.removeAttribute('max');
    }
  }
  updateMaxAmountInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment, #product-form-sub-navigation, #product-form-sticky-mobile`
    );
    productForms.forEach((productForm) => {
      const inputs = productForm.querySelectorAll('[data-max-amount]');
      if (inputs.length) {
        inputs.forEach((input) => {
          if (input.id !== `variant-${this.currentVariant.id}`) {
            input.disabled = true;
          } else input.disabled = false;
        });
      }
    });
  }
  checkNotificationForm() {
    let variantId = null;
    let variantName = null;
    if (!this.currentVariant) {
      variantId = document.querySelector('.product-selected-variant').getAttribute('data-product-selected-variant');
      variantName = document.querySelector('.product-selected-variant').getAttribute('data-product-selected-name');
    } else {
      variantId = this.currentVariant.id.toString();
      variantName = this.currentVariant.name;
    }
    // let normalProductInfo = document.querySelector('[data-normal-purchase-info]');
    let notificationFormContainer = document.querySelector('[data-notification-form-container]');
    let notificationForm = document.querySelector('[data-notification-form]');
    let notificationIds = notificationFormContainer?.getAttribute('data-notify-me-ids');
    if (notificationIds) {
      notificationIds = notificationIds.split(', ');
      notificationIds = notificationIds.filter((id) => {
        return id != '';
      });
      if (notificationIds.includes(variantId)) {
        if (!notificationFormContainer.classList.contains('notify-me-form__container--active')) {
          notificationFormContainer.classList.add('notify-me-form__container--active');
          // normalProductInfo.classList.add('hidden');
          document.querySelector('div#purchase-info__salable__elements').setAttribute('style', 'display:none;');
        }
      } else {
        if (notificationFormContainer.classList.contains('notify-me-form__container--active')) {
          notificationFormContainer.classList.remove('notify-me-form__container--active');
          // normalProductInfo.classList.remove('hidden');
          document.querySelector('div#purchase-info__salable__elements').setAttribute('style', 'display:block');
        }
      }
      notificationForm.setAttribute('data-variant-name', variantName);
      notificationForm.setAttribute('data-product-variant', variantId);
    }
  }

  fetchMainSection() {
    return new Promise((resolve, reject) => {
      const sellingPlanRadioEl = document.querySelector('selling-plan-radios');
      fetch(
        `${this.dataset.url}?variant=${this.currentVariant.id}${
          sellingPlanRadioEl && `&selling_plan=${sellingPlanRadioEl.selling_plan}`
        }&section_id=${this.dataset.section}`
      )
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          resolve(html);
        });
    });
  }

  renderProductInfo(html) {
    const id = `price-${this.dataset.section}`;
    const destination = document.getElementById(id);
    const source = html.getElementById(id);

    if (source && destination) destination.innerHTML = source.innerHTML;
  }

  renderVariantSelect(html) {
    const id = `variant-select--${this.dataset.section}`;
    const destination = document.getElementById(id);
    const source = html.getElementById(id);

    if (source && destination) destination.innerHTML = source.innerHTML;
  }

  renderSellingPlanPrices(container) {
    const selector = 'selling-plan-radios';
    const element = document.querySelector(selector);
    if (element) element.handleOnPriceChange(container);
  }

  renderSellingPlanRadios() {
    const selector = 'selling-plan-radios';
    const element = document.querySelector(selector);
    if (element) element.handleOnVariantChange();
  }

  renderRelatedSellingPlanRadios() {
    const selector = 'related-selling-plan-radios';
    const element = document.querySelector(selector);
    if (element) element.handleOnVariantChange();
  }

  renderRelatedSellingPlanRadios() {
    const selector = 'related-service-selling-plan-radios';
    const element = document.querySelector(selector);
    if (element) element.handleOnVariantChange();
  }

  renderServicePlanRadios() {
    const selector = 'service-plan-radios';
    const element = document.querySelector(selector);
    if (element) element.handleOnVariantChange();
  }

  renderAddonProducts(html) {
    const id = `product-addons-container`;
    const destination = document.getElementById(id);
    const source = html.getElementById(id);

    if (source && destination) destination.innerHTML = source.innerHTML;
  }

  renderSubNavigation(selector) {
    const container = document.querySelector(`.${selector}`);

    if (!container || this.hasAttribute('data-featured-product')) return;

    const sellingPlanRadioEl = document.querySelector('selling-plan-radios');

    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}${sellingPlanRadioEl && `&selling_plan=${sellingPlanRadioEl.selling_plan}`}`)
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${container.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(id);
        const source = html.getElementById(id);

        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${container.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
        this.renderServicePlanRadios();
        this.renderSellingPlanPrices(container);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-sub-navigation, #product-form-sticky-mobile`
    );
    if (!productForms) return;
    const addButtons = Array.from(productForms).map((el) => el.querySelector('[name="add"]'));
    const addButtonTexts = Array.from(productForms).map((el) => el.querySelector('[name="add"] > span'));

    if (!addButtons) return;

    if (window.variant_metafields[this.currentVariant.id]) {
      disable =
        window.variant_metafields[this.currentVariant.id].makeUnavailable === 'true'
          ? true
          : !window.variant_metafields[this.currentVariant.id].availableForSale;
      text = window.variant_metafields[this.currentVariant.id].makeUnavailableText
        ? window.variant_metafields[this.currentVariant.id].makeUnavailableText
        : text;
    }

    
    try {
      if (disable) {
        addButtons.forEach((el) => el.setAttribute('disabled', 'disabled'));
        if (text) addButtonTexts.forEach((el) => (el.textContent = text));
      } else {
        addButtons.forEach((el) => el.removeAttribute('disabled'));
        addButtonTexts.forEach((el) => (el.textContent = window.variantStrings.addToCart));
      }
    } catch (error) {
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    const featured_media_override = this.querySelector('[data-featured-media-override]');
    if (featured_media_override) {
      const { preview_image, id } = JSON.parse(featured_media_override.textContent);
      this.variantData[0].featured_media.id = id;
      this.variantData[0].featured_media.preview_image = preview_image;
    }
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class SectionAddToCart extends HTMLElement {
  constructor() {
    super();

    this.cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    this.cartDrawerRecommendation = this.querySelector('cart-drawer-recommendation');
    const buttons = this.querySelectorAll('[data-atc]');
    this.buttonArr = Array.from(buttons);

    this.buttonArr.forEach((button) => button.addEventListener('click', this.onButtonClick.bind(this)));
  }

  enableLoading() {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    this.buttonArr.forEach((button) => button.classList.add('hidden'));

    const loadingSpinner = this.querySelector('.loading-overlay');
    loadingSpinner.classList.remove('hidden');
  }

  disableLoading() {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    this.buttonArr.forEach((button) => button.classList.remove('hidden'));

    const loadingSpinner = this.querySelector('.loading-overlay');
    loadingSpinner.classList.add('hidden');
  }

  onButtonClick(event) {
    event.preventDefault();

    this.enableLoading(event.target);

    const {
      target: {
        dataset: { sellingPlan, atc }
      }
    } = event;

    const sections = this.cart.getSectionsToRender().map((section) => section.id);

    const item = {
      id: Number(atc),
      quantity: 1
    };

    if (sellingPlan) item.selling_plan = Number(sellingPlan);

    const formData = {
      items: [item],
      sections
    };
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify(formData)
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        if (this.cartDrawerRecommendation) {
          data.resetRecommendations = true;
        }
        this.handleRender(data);
      })
      .catch((error) => {
        console.error('Error:', error);
      })
      .finally(() => {
        this.disableLoading(event.target);
        if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
      });
  }

  handleRender(response) {
    this.error = false;
    this.cart.renderContents(response);
    if (window.Rebuy && document.querySelector('[data-rebuy-id]')) window.Rebuy.init();
  }
}

customElements.define('section-add-to-cart', SectionAddToCart);

/** Resize Container

  Applys min-widths and max-widths attributes to the child element of the
  <container-queries></container-queries> based on the width-breakpoints 
  attribute applied to the <container-queries></container-queries> element

  Usage:
   
    HTML: <container-queries width-breakpoints="320,768,1024]">
            <div class="container"></div>
          </container-queries>

    CSS: .container[min-width*="(320)"] {
*/
class ContainerQueries extends HTMLElement {
  constructor() {
    super();

    this.widthBreakpoints = this.getAttribute('width-breakpoints').split(',');

    this.setupObserver();
  }

  setupObserver() {
    this.resizeObserver = new ResizeObserver((entries) => {
      for (let entry of entries) {
        if (entry.borderBoxSize) {
          this.width = entry.borderBoxSize[0].inlineSize;
          this.minWidths = this.widthBreakpoints.filter((widthBreakpoint) => parseInt(this.width) >= parseInt(widthBreakpoint));
          this.maxWidths = this.widthBreakpoints.filter((widthBreakpoint) => parseInt(this.width) < parseInt(widthBreakpoint));
          this.children[0].setAttribute('min-widths', `(${this.minWidths.join(')(')})`);
          this.children[0].setAttribute('max-widths', `(${this.maxWidths.join(')(')})`);
        }
      }
    });

    this.resizeObserver.observe(this.children[0]);
  }
}

customElements.define('container-queries', ContainerQueries);

var links = document.links;
for (let i = 0, linksLength = links.length; i < linksLength; i++) {
  if (links[i].hostname !== window.location.hostname && links[i].hostname !== "middleware.auth.wyze.com") {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}
